import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "information-container",
    ref: "information-container"
};
const _hoisted_2 = /*#__PURE__*/ _createTextVNode("These molecular properties depend on protonation. Use ");
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" to protonate your compound(s) at a specific pH.");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Viewer2D = _resolveComponent("Viewer2D");
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_MolProps = _resolveComponent("MolProps");
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_Alert = _resolveComponent("Alert");
    return (_ctx.smiles !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Viewer2D, {
                width: "100%",
                maxHeight: 150,
                smiles: _ctx.smiles
            }, null, 8, ["smiles"]),
            _createVNode(_component_FormWrapper, { cls: "mb-3" }, {
                default: _withCtx(() => [
                    _createVNode(_component_FormInput, {
                        modelValue: _ctx.smiles,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.smiles) = $event)),
                        readonly: true,
                        placeHolder: "SMILES..."
                    }, null, 8, ["modelValue"])
                ]),
                _: 1
            }),
            _createVNode(_component_MolProps, {
                smiles: _ctx.smiles,
                treeNode: _ctx.treeNode
            }, null, 8, ["smiles", "treeNode"]),
            _createVNode(_component_Alert, {
                type: "warning",
                extraStyle: "display: inline-block;",
                minimal: true
            }, {
                default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_PluginPathLink, { plugin: "protonatecomps" }),
                    _hoisted_3
                ]),
                _: 1
            })
        ], 512))
        : _createCommentVNode("", true);
}
